import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ReactNode } from 'react';

interface PublicRouteProps {
  readonly children: ReactNode;
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Cargando...</div>
      </div>
    );
  }

  // Si ya está autenticado, redirigir a home
  if (currentUser) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
